import { useMutation, gql } from "@apollo/client";

const REQUEST_PASSWORD_RESET = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export const useRequestPasswordResetMutation = () => {
  const [requestPasswordReset, { loading, error }] = useMutation(REQUEST_PASSWORD_RESET, {
    onError: (error) => {
      console.error("Error requesting password reset:", error.message);
    },
  });

  const handleRequestPasswordReset = async (email: string) => {
    try {
      const result = await requestPasswordReset({
        variables: { email },
      });
      return { success: result.data?.requestPasswordReset ?? false };
    } catch (error: any) {
      console.error("Error occurred during password reset request:", error);
      return { 
        success: false, 
        error: error?.message || "An error occurred. Please try again." 
      };
    }
  };

  return {
    handleRequestPasswordReset,
    loading,
    error,
  };
};




















